module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_6_1.a38f0d94.png";